import React from 'react';
import {AppGridLayout,AppTable,AppTableSearch,AppSearchItem,AppButton,AppRow,AppGridBar} from 'qcc';
import {AppAction} from 'qcc';
import {default as EditForm} from './EditForm';
import {default as AuthorizeForm} from './AuthorizeForm';
import {default as RoleUserIndex} from './RoleUserIndex';
import api,{AppRole} from 'api';

export default class extends React.Component {

    addRole = () =>{
        let role = {is_admin:0,name:''}
        AppAction.openDialog(<EditForm mode={1} formData={role} afterSave={this.afterSave}/>,{title:'新增角色'})
    }

    editRole = (role?:any) =>{
        AppAction.openDialog(<EditForm mode={2} formData={role} id={role.id} afterSave={this.afterSave}/>,{title:'编辑角色'})
    }

    deleteRole = async (role?:AppRole) =>{
        if(await AppAction.deleteConfirm('您确定要删除该记录吗？')){
           let res = await api.role.deleteRole(role);
           AppAction.successMsg('删除成功！');
           this.refGrid.current && this.refGrid.current.state.refTable.fetch();
           return true;
        }

        return false;
    }

    authorize = (role?:AppRole) =>{
        let formCompent = <AuthorizeForm formData={{...role}}/>
        AppAction.openDrawer(formCompent,{title:'角色授权',width:920})
    }

    openRoleUser = (role?:AppRole) =>{
        let title = `角色授权(${role.name})`
        let formCompent = <RoleUserIndex roleId={role.id}/>
        AppAction.openDrawer(formCompent,{title,width:920})
    }

    afterSave = () =>{
        this.refGrid.current && this.refGrid.current.state.refTable.fetch();
        AppAction.closeDialog();
    }

    refGrid = React.createRef<AppGridLayout>();

	render() {
		return (
        <AppGridLayout ref={this.refGrid}>
            <AppGridLayout.SearchArea>
                <AppTableSearch>
                    <AppTableSearch.Common>
                        <AppSearchItem.SearchInput placeholder='请录入姓名' keyName='common' field='name'/>
                    </AppTableSearch.Common>
                </AppTableSearch>
            </AppGridLayout.SearchArea>
            <AppGridLayout.MenuArea>
                <AppGridBar>
                    <AppGridBar.Right>
                        <AppButton label='新增' actionCode='00010101'  type='primary' action={this.addRole}/>
                    </AppGridBar.Right>
                </AppGridBar>
            </AppGridLayout.MenuArea>
            <AppGridLayout.GridArea>
                <AppTable paging sqlId='sql.role.grid'>
                    <AppTable.ColIndex />
                    <AppTable.Col title='名称' field='name' />
                    <AppTable.ColAction render={(data:AppRole,dataIndex:number)=>{
                        return (<AppRow itemSplit={10} style={{float:'right'}}>
                            <AppButton type='link' label='用户分配' actionCode='00010105' action={()=>this.openRoleUser(data)} />
                            <AppButton type='link' label='授权' actionCode='00010104' action={()=>this.authorize(data)} />
                            <AppButton type='link' label='编辑' actionCode='00010102'  action={()=>this.editRole(data)} />
                            <AppButton type='link' label='删除' actionCode='00010103'  auditAction={()=>this.deleteRole(data)} />
                        </AppRow>)
                    }}/>
                </AppTable>
            </AppGridLayout.GridArea>
        </AppGridLayout>)
	}
}


// WEBPACK FOOTER //
// ./src/page/application/role/IndexGrid.tsx